import translations from './translations';

const useTranslation = () => {
  const t = translations;

  return { t };
};

export default useTranslation;
